import hash from 'object-hash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { RESPONSE_STATUS } from '../../constnats/general';
import { TableUpdateFiltersType, TableUpdateFiltersWithoutPage } from '../../schemas/tableUpdate.schemas';
import Alert from '../../utils/alert';
import TableUpdates from '../../service/tableUpdates';

function useTableUpdates(filters: TableUpdateFiltersWithoutPage) {
    const [updates, setUpdates] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);

    const memoizedFilters: TableUpdateFiltersType = useMemo(() => ({ ...filters, page }), [hash(filters), page]);

    const fetchUpdates = useCallback(() => {
        setLoading(true);
        TableUpdates.find(memoizedFilters).then((response: any) => {
            if (response.status === RESPONSE_STATUS.SUCCESS) {
                setUpdates(response.data.content);
                setTotalPages(response.data.totalPages);
            } else {
                Alert.warn(response.message);
            }
            setLoading(false);
        });
    }, [memoizedFilters]);

    useEffect(() => {
        fetchUpdates();
    }, [fetchUpdates]);

    return { updates, loading, refetch: fetchUpdates, page, setPage, totalPages };
}

export default useTableUpdates;
